import React, { Fragment } from 'react'

import PropTypes from 'prop-types'

import './footer.css'

const Footer = (props) => {
  return (
    <footer
      className={`footer-container1 thq-section-padding ${props.rootClassName} `}
    >
      <div className="footer-thq-max-width-elm thq-section-max-width">
        <div className="footer-thq-content-elm">
          <div className="footer-thq-newsletter-elm">
            <img
              alt={props.logoAlt}
              src={props.logoSrc}
              className="footer-thq-image1-elm"
            />
            <span className="thq-body-small">
              Підпишіться на нашу розсилку, щоб отримувати наші останні новини.
            </span>
            <div className="footer-thq-actions-elm">
              <div className="footer-thq-form-elm">
                <div className="footer-container2">
                  <input
                    type="email"
                    className="footer-thq-text-input-elm thq-input"
                  />
                </div>
                <button className="thq-button-outline footer-thq-button-elm">
                  <span className="thq-body-small">
                    {props.sendForm ?? (
                      <Fragment>
                        <span className="footer-text6">Надіслати</span>
                      </Fragment>
                    )}
                  </span>
                </button>
              </div>
            </div>
          </div>
          <div className="footer-thq-links-elm">
            <div className="footer-thq-column1-elm">
              <strong className="thq-body-large footer-thq-column1-title-elm">
                {props.column1Title ?? (
                  <Fragment>
                    <span className="footer-text4">Company</span>
                  </Fragment>
                )}
              </strong>
              <div className="footer-thq-footer-links-elm1">
                <a
                  href={props.textUrl?.['url']}
                  target={props.textUrl?.['newTab'] ? '_blank' : undefined}
                  rel={
                    props.textUrl?.['newTab']
                      ? 'noreferrer noopener'
                      : undefined
                  }
                >
                  {props.text ?? (
                    <Fragment>
                      <span className="footer-text8">Link</span>
                    </Fragment>
                  )}
                </a>
                <a
                  href={props.textUrl1?.['url']}
                  target={props.textUrl1?.['newTab'] ? '_blank' : undefined}
                  rel={
                    props.textUrl1?.['newTab']
                      ? 'noreferrer noopener'
                      : undefined
                  }
                >
                  {props.text1 ?? (
                    <Fragment>
                      <span className="footer-text3">Link</span>
                    </Fragment>
                  )}
                </a>
                <a
                  href={props.textUrl12?.['url']}
                  target={props.textUrl12?.['newTab'] ? '_blank' : undefined}
                  rel={
                    props.textUrl12?.['newTab']
                      ? 'noreferrer noopener'
                      : undefined
                  }
                >
                  {props.text12 ?? (
                    <Fragment>
                      <span className="footer-text9">Link</span>
                    </Fragment>
                  )}
                </a>
                <a
                  href={props.textUrl11?.['url']}
                  target={props.textUrl11?.['newTab'] ? '_blank' : undefined}
                  rel={
                    props.textUrl11?.['newTab']
                      ? 'noreferrer noopener'
                      : undefined
                  }
                >
                  {props.text11 ?? (
                    <Fragment>
                      <span className="footer-text7">Link</span>
                    </Fragment>
                  )}
                </a>
                <a
                  href={props.textUrl111?.['url']}
                  target={props.textUrl111?.['newTab'] ? '_blank' : undefined}
                  rel={
                    props.textUrl111?.['newTab']
                      ? 'noreferrer noopener'
                      : undefined
                  }
                >
                  {props.text111 ?? (
                    <Fragment>
                      <span className="footer-text2">Link</span>
                    </Fragment>
                  )}
                </a>
              </div>
            </div>
            <div className="footer-thq-column3-elm">
              <strong className="thq-body-large footer-thq-social-link1-title-elm">
                {props.socialLinkTitle ?? (
                  <Fragment>
                    <span className="footer-text1">
                      Connect with Us on Social Media
                    </span>
                  </Fragment>
                )}
              </strong>
              <div className="footer-thq-social-links-elm">
                <a
                  href="https://www.instagram.com/evac_616?igsh=emNyeHM1Z255N3Az"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="footer-link1"
                >
                  <div className="footer-thq-instagram-elm">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      className="thq-icon-small"
                    >
                      <path
                        d="M12.001 9a3 3 0 1 0 0 6a3 3 0 0 0 0-6m0-2a5 5 0 1 1 0 10a5 5 0 0 1 0-10m6.5-.25a1.25 1.25 0 0 1-2.5 0a1.25 1.25 0 0 1 2.5 0M12.001 4c-2.474 0-2.878.007-4.029.058c-.784.037-1.31.142-1.798.332a2.9 2.9 0 0 0-1.08.703a2.9 2.9 0 0 0-.704 1.08c-.19.49-.295 1.015-.331 1.798C4.007 9.075 4 9.461 4 12c0 2.475.007 2.878.058 4.029c.037.783.142 1.31.331 1.797c.17.435.37.748.702 1.08c.337.336.65.537 1.08.703c.494.191 1.02.297 1.8.333C9.075 19.994 9.461 20 12 20c2.475 0 2.878-.007 4.029-.058c.782-.037 1.308-.142 1.797-.331a2.9 2.9 0 0 0 1.08-.703c.337-.336.538-.649.704-1.08c.19-.492.296-1.018.332-1.8c.052-1.103.058-1.49.058-4.028c0-2.474-.007-2.878-.058-4.029c-.037-.782-.143-1.31-.332-1.798a2.9 2.9 0 0 0-.703-1.08a2.9 2.9 0 0 0-1.08-.704c-.49-.19-1.016-.295-1.798-.331C14.926 4.006 14.54 4 12 4m0-2c2.717 0 3.056.01 4.123.06c1.064.05 1.79.217 2.427.465c.66.254 1.216.598 1.772 1.153a4.9 4.9 0 0 1 1.153 1.772c.247.637.415 1.363.465 2.428c.047 1.066.06 1.405.06 4.122s-.01 3.056-.06 4.122s-.218 1.79-.465 2.428a4.9 4.9 0 0 1-1.153 1.772a4.9 4.9 0 0 1-1.772 1.153c-.637.247-1.363.415-2.427.465c-1.067.047-1.406.06-4.123.06s-3.056-.01-4.123-.06c-1.064-.05-1.789-.218-2.427-.465a4.9 4.9 0 0 1-1.772-1.153a4.9 4.9 0 0 1-1.153-1.772c-.248-.637-.415-1.363-.465-2.428C2.012 15.056 2 14.717 2 12s.01-3.056.06-4.122s.217-1.79.465-2.428a4.9 4.9 0 0 1 1.153-1.772A4.9 4.9 0 0 1 5.45 2.525c.637-.248 1.362-.415 2.427-.465C8.945 2.013 9.284 2 12.001 2"
                        fill="currentColor"
                      ></path>
                    </svg>
                    <span className="thq-body-small">Instagram</span>
                  </div>
                </a>
                <a
                  href="https://youtube.com/@evac_vn"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="footer-link2"
                >
                  <div className="footer-thq-youtube-elm">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      className="thq-icon-small"
                    >
                      <g fill="none">
                        <g clipPath="url(#akarIconsYoutubeFill0)">
                          <path
                            d="M23.5 6.507a2.8 2.8 0 0 0-.766-1.27a3.05 3.05 0 0 0-1.338-.742C19.518 4 11.994 4 11.994 4a77 77 0 0 0-9.39.47a3.16 3.16 0 0 0-1.338.76c-.37.356-.638.795-.778 1.276A29 29 0 0 0 0 12c-.012 1.841.151 3.68.488 5.494c.137.479.404.916.775 1.269s.833.608 1.341.743c1.903.494 9.39.494 9.39.494a77 77 0 0 0 9.402-.47a3.05 3.05 0 0 0 1.338-.742a2.8 2.8 0 0 0 .765-1.27A28.4 28.4 0 0 0 24 12.023a26.6 26.6 0 0 0-.5-5.517M9.602 15.424V8.577l6.26 3.424z"
                            fill="currentColor"
                          ></path>
                        </g>
                        <defs>
                          <clippath id="akarIconsYoutubeFill0">
                            <path d="M0 0h24v24H0z" fill="#fff"></path>
                          </clippath>
                        </defs>
                      </g>
                    </svg>
                    <span className="thq-body-small">Youtube</span>
                    <svg
                      viewBox="0 0 1024 1024"
                      className="footer-icon19"
                    ></svg>
                    <path d="M406.286 644.571l276.571-142.857-276.571-144.571v287.429zM512 152c215.429 0 358.286 10.286 358.286 10.286 20 2.286 64 2.286 102.857 43.429 0 0 31.429 30.857 40.571 101.714 10.857 82.857 10.286 165.714 10.286 165.714v77.714s0.571 82.857-10.286 165.714c-9.143 70.286-40.571 101.714-40.571 101.714-38.857 40.571-82.857 40.571-102.857 42.857 0 0-142.857 10.857-358.286 10.857v0c-266.286-2.286-348-10.286-348-10.286-22.857-4-74.286-2.857-113.143-43.429 0 0-31.429-31.429-40.571-101.714-10.857-82.857-10.286-165.714-10.286-165.714v-77.714s-0.571-82.857 10.286-165.714c9.143-70.857 40.571-101.714 40.571-101.714 38.857-41.143 82.857-41.143 102.857-43.429 0 0 142.857-10.286 358.286-10.286v0z"></path>
                    <svg
                      viewBox="0 0 1024 1024"
                      className="footer-icon21"
                    ></svg>
                    <path d="M406.286 644.571l276.571-142.857-276.571-144.571v287.429zM512 152c215.429 0 358.286 10.286 358.286 10.286 20 2.286 64 2.286 102.857 43.429 0 0 31.429 30.857 40.571 101.714 10.857 82.857 10.286 165.714 10.286 165.714v77.714s0.571 82.857-10.286 165.714c-9.143 70.286-40.571 101.714-40.571 101.714-38.857 40.571-82.857 40.571-102.857 42.857 0 0-142.857 10.857-358.286 10.857v0c-266.286-2.286-348-10.286-348-10.286-22.857-4-74.286-2.857-113.143-43.429 0 0-31.429-31.429-40.571-101.714-10.857-82.857-10.286-165.714-10.286-165.714v-77.714s-0.571-82.857 10.286-165.714c9.143-70.857 40.571-101.714 40.571-101.714 38.857-41.143 82.857-41.143 102.857-43.429 0 0 142.857-10.286 358.286-10.286v0z"></path>
                    <svg
                      viewBox="0 0 1024 1024"
                      className="footer-icon23"
                    ></svg>
                    <path d="M406.286 644.571l276.571-142.857-276.571-144.571v287.429zM512 152c215.429 0 358.286 10.286 358.286 10.286 20 2.286 64 2.286 102.857 43.429 0 0 31.429 30.857 40.571 101.714 10.857 82.857 10.286 165.714 10.286 165.714v77.714s0.571 82.857-10.286 165.714c-9.143 70.286-40.571 101.714-40.571 101.714-38.857 40.571-82.857 40.571-102.857 42.857 0 0-142.857 10.857-358.286 10.857v0c-266.286-2.286-348-10.286-348-10.286-22.857-4-74.286-2.857-113.143-43.429 0 0-31.429-31.429-40.571-101.714-10.857-82.857-10.286-165.714-10.286-165.714v-77.714s-0.571-82.857 10.286-165.714c9.143-70.857 40.571-101.714 40.571-101.714 38.857-41.143 82.857-41.143 102.857-43.429 0 0 142.857-10.286 358.286-10.286v0z"></path>
                  </div>
                </a>
                <a
                  href="https://www.tiktok.com/@evac_vn?_t=ZM-8wMKjHDJasA&amp;_r=1"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="footer-link3"
                >
                  <div className="footer-thq-tik-tok-elm">
                    <svg
                      width="48"
                      height="48"
                      viewBox="0 0 48 48"
                      className="thq-icon-small"
                    >
                      <path
                        d="M21.358 19.14q-8.833-.426-12.28 6.298c-3.446 6.725-.598 17.729 10.9 17.729c11.5 0 11.832-11.112 11.832-12.276V17.875q3.69 2.336 6.22 2.813q2.533.476 3.22.422v-6.476q-2.342-.282-4.05-1.076c-1.709-.794-5.096-2.997-5.096-6.226q.003.024 0-2.499h-7.118q-.031 23.724 0 26.058c.031 2.334-1.78 5.6-5.45 5.6c-3.672 0-5.483-3.263-5.483-5.367c0-1.288.443-3.155 2.272-4.538c1.085-.82 2.59-1.148 5.033-1.148z"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="3.833"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                    <span className="thq-body-small">TikTok</span>
                  </div>
                </a>
                <a
                  href="https://maps.app.goo.gl/zap2E1F2MfhoKEz66?g_st=atm"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="footer-link4"
                >
                  <div className="footer-thq-google-map-elm">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      className="thq-icon-small"
                    >
                      <path
                        d="M18.27 6c1.01 2.17.78 4.73-.33 6.81c-.94 1.69-2.29 3.12-3.44 4.69c-.5.7-1 1.45-1.37 2.26c-.13.27-.22.55-.32.83s-.19.56-.28.84c-.09.26-.2.57-.53.57c-.39 0-.5-.44-.58-.74c-.24-.73-.48-1.43-.85-2.1c-.42-.79-.95-1.52-1.49-2.23zM9.12 8.42l-3.3 3.92c.61 1.29 1.52 2.39 2.39 3.49c.21.25.42.51.62.78L13 11.67l-.04.01c-1.46.5-3.08-.24-3.66-1.68c-.08-.17-.14-.37-.18-.57a3 3 0 0 1 0-1zm-2.54-3.8l-.01.01c-1.62 2.05-1.9 4.9-.93 7.31L9.63 7.2l-.05-.05zm7.64-2.26L11 6.17l.04-.01c1.34-.46 2.84.12 3.52 1.34c.15.28.27.58.31.88c.06.38.08.65.01 1.02v.01l3.2-3.8a7 7 0 0 0-3.85-3.24zM9.89 6.89l3.91-4.65l-.04-.01C13.18 2.08 12.59 2 12 2c-1.97 0-3.83.85-5.15 2.31l-.02.01z"
                        fill="currentColor"
                      ></path>
                    </svg>
                    <span className="thq-body-small">Google Map</span>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-thq-credits-elm">
          <div className="footer-thq-row-elm">
            <span className="thq-body-small">
              {props.content3 ?? (
                <Fragment>
                  <span className="footer-text5">
                    © 2025 Evac Towing Service. All Rights Reserved.
                  </span>
                </Fragment>
              )}
            </span>
            <div className="footer-thq-footer-links-elm2"></div>
          </div>
        </div>
      </div>
    </footer>
  )
}

Footer.defaultProps = {
  socialLinkTitle: undefined,
  textUrl111: {
    url: 'https://example.com',
    newTab: false,
  },
  text111: undefined,
  text1: undefined,
  textUrl1: {
    url: 'https://example.com',
    newTab: false,
  },
  column1Title: undefined,
  textUrl12: {
    url: 'https://example.com',
    newTab: false,
  },
  content3: undefined,
  textUrl11: {
    url: 'https://example.com',
    newTab: false,
  },
  logoAlt: 'Evac Towing Service Logo',
  sendForm: undefined,
  rootClassName: '',
  text11: undefined,
  textUrl: {
    url: 'https://example.com',
    newTab: false,
  },
  text: undefined,
  text12: undefined,
  logoSrc: 'https://presentation-website-assets.teleporthq.io/logos/logo.png',
}

Footer.propTypes = {
  socialLinkTitle: PropTypes.element,
  textUrl111: PropTypes.object,
  text111: PropTypes.element,
  text1: PropTypes.element,
  textUrl1: PropTypes.object,
  column1Title: PropTypes.element,
  textUrl12: PropTypes.object,
  content3: PropTypes.element,
  textUrl11: PropTypes.object,
  logoAlt: PropTypes.string,
  sendForm: PropTypes.element,
  rootClassName: PropTypes.string,
  text11: PropTypes.element,
  textUrl: PropTypes.object,
  text: PropTypes.element,
  text12: PropTypes.element,
  logoSrc: PropTypes.string,
}

export default Footer
